import Logo from "@/components/ui/Logo";
import NavigationInfo from "./NavigationInfo";
import NavigationItem from "./NavigationItem";

export default function Navigation({ options, mainMenu, handleLinkClick, infoMenu, lang, cdn }) {
  return (
    <>
      <div className="flex flex-col gap-5 ">
        <Logo options={options} cdn={cdn} />
        <nav role="navigation" aria-label="Main">
          <menu className="flex flex-col gap-2">
            {mainMenu?.map((item, index) => (
              <NavigationItem key={index} {...item} handleLinkClick={handleLinkClick} />
            ))}
          </menu>
        </nav>
      </div>
      <NavigationInfo infoMenu={infoMenu} handleLinkClick={handleLinkClick} lang={lang} />
    </>
  );
}
